import { Layout } from '@/Layout';
import { BackLink } from '@/components/BackLink';
import { ImportExportHistoryTableViewWrapper } from '@/features/import_export_histories/Table';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import styles from './importExportHistory.module.scss';

const cx = classnames.bind(styles);

type Props = {
  location: {
    state?: ImportExportHistoryLocationState;
    pathname: string;
  };
};

type ImportExportHistoryLocationState = { from?: string };

function isImportExportHistoryState(
  s: unknown
): s is ImportExportHistoryLocationState {
  if (s === null || typeof s !== 'object' || !('from' in s)) return false;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- narrow React Router location state type
  const from = (s as ImportExportHistoryLocationState).from;
  return from === undefined || typeof from === 'string';
}

export const ImportExportHistory = (props: Props) => {
  const { t } = useTranslation();
  const { location } = props;

  const state = isImportExportHistoryState(location.state)
    ? location.state
    : undefined;

  return (
    <Layout
      title={t('import_export_history_page_title')}
      backLink={
        state?.from ? (
          <BackLink
            href={state.from}
            text={t('import_export_history_back_link')}
          />
        ) : undefined
      }
    >
      <div className={cx('container')}>
        <p className={cx('description')}>
          {t('import_export_history_description')}
        </p>
        <ImportExportHistoryTableViewWrapper />
      </div>
    </Layout>
  );
};
ImportExportHistory.displayName = 'ImportExportHistory';
